import React from 'react'
import FormROValue from '../../../../../library/form/components/FormROValue1';
import FormLink from '../../../../../library/form/components/FormLink';
import FormButton from '../../../../../library/form/components/FormActionButton2';
import {ProdIOListQtyCell, ProdIOListUnitCell } from './ProdIOListQtyCell';

const ProdIOOExiViewRow = (props) => {
    const { formObject, rowKey } = props;

    return (
            <ul className="uiDPEditLine uiTableRowLevel1">
                <li className="uiColumnLeft uiColumn130">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "id" }} />
                </li>
                <li className="uiColumnLeft uiColumn350">
                    <FormLink formObject={formObject} rowKey={rowKey} kscFormula=""
                        action={{ paramName: "actualItem", actionId: "show" }}
                        linkProp={{ target: "_blank" }}
                    ></FormLink>
                </li>
                <ProdIOListUnitCell formObject={formObject} rowKey={rowKey} param1="unit1" param2="unit2" />
                <ProdIOListQtyCell formObject={formObject} rowKey={rowKey} param1="qtyRequired1" param2="qtyRequired2" format="#" />
                <ProdIOListQtyCell formObject={formObject} rowKey={rowKey} param1="qtyAllocated1" param2="qtyAllocated2" format="#"/>
                <li className="uiColumnCenter uiColumn70 uiActionBlock">
                    <FormButton formObject={formObject} rowKey={rowKey}
                        starIcon="edit"
                        onlyIcon={true}
                        tooltip="Edit"
                        starIconClassName="uiColorNeutralAction"
                                action={{ actionId: "edit",  
                                paramName: "editBtn",
                                actionParam: {pathKey: "OEXI"}, containerKey: "popup" }}
                                className="" ></FormButton>
                    <FormButton formObject={formObject} rowKey={rowKey}
                            starIcon="clear"
                            onlyIcon={true}
                            tooltip="Delete"
                            starIconClassName="uiColorNegativeAction"
                            action={{ actionId: "del",  
                            paramName: "delBtn",
                            actionParam: {pathKey: "OEXI"}, containerKey: "row" }}
                            className="" ></FormButton>
                </li>
            </ul>
        )
}

export default ProdIOOExiViewRow
